/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-table': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M1.5 0h11A1.5 1.5 0 0 1 14 1.5v11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-11A1.5 1.5 0 0 1 1.5 0zm11 1h-2.426v12H12.5a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5zM5.075 1h4v12h-4V1zm-1 0H1.5a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h2.575V1z" _fill="#234357"/>'
  }
})
